import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../contexts/LocaleContext.jsx';
import '../styles/Logo.css';

const LOGO_ASSETS = {
  cherry: '/assets/images/SongShakeCherryRed.png',
};

/**
 * The SongShake logo. By default it links to /home for everyone; RequireAuth
 * sends a signed-out viewer on to /login. Pass linkToHome={false} where
 * leaving the page must go through the page's own exit path (the OAuth
 * callback).
 */
function Logo({ size = 'large', variant = 'cherry', linkToHome = true }) {
  const t = useT();
  const className = size === 'small' ? 'logo-container-small' : 'logo-container';
  const logoSrc = LOGO_ASSETS[variant] ?? LOGO_ASSETS.cherry;

  const content = (
    <div className="title-container">
      <span className="title_SongShake">
        <img src={logoSrc} alt={t('navigation.logoAlt')} />
      </span>
    </div>
  );

  if (!linkToHome) {
    return (
      <div className={className}>
        <div className="logo">{content}</div>
      </div>
    );
  }

  return (
    <div className={className}>
      <Link to="/home" className="logo logo-link" aria-label={t('navigation.homeLink')}>
        {content}
      </Link>
    </div>
  );
}

export default Logo;
